// Versão do sistema, no formato AAAA.M.D.N
// N reinicia em 1 a cada novo dia e é incrementado automaticamente a cada novo commit.
// Gerado automaticamente durante o build em 23/10/2026, 22:26:13.
export const APP_VERSION = '2026.10.23.1';
